import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Center, Spinner } from '@chakra-ui/react';

interface PrivateRouteProps {
  children: React.ReactNode;
}

export function PrivateRoute({ children }: PrivateRouteProps) {
  const { user, userProfile, loading } = useAuth();
  const location = useLocation();

  console.log('PrivateRoute - Auth state:', { 
    hasUser: !!user, 
    hasProfile: !!userProfile, 
    loading, 
    path: location.pathname 
  });

  // Show loading spinner while checking authentication status
  if (loading) {
    console.log('PrivateRoute - Auth is loading');
    return (
      <Center h="100vh">
        <Spinner 
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
          color="blue.500"
          size="xl"
        />
      </Center>
    );
  }
  
  // Redirect to signup if not authenticated
  if (!user) {
    console.log('PrivateRoute - No user, redirecting to signup');
    // Save the intended destination so we can redirect after login
    return <Navigate to="/signup" state={{ from: location }} replace />;
  }

  // Optionally check for profile existence
  if (!userProfile) {
    console.log('PrivateRoute - User exists but no profile, waiting for profile data');
    // Show loading spinner while profile loads
    return (
      <Center h="100vh">
        <Spinner 
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
          color="blue.500"
          size="xl"
        />
      </Center>
    );
  }

  // If authenticated, render the protected component
  console.log('PrivateRoute - User is authenticated with profile, rendering protected content');
  return <>{children}</>;
} 